// extracted by mini-css-extract-plugin
export var animationContainer = "_kg-0";
export var footer = "_kg-1";
export var gray = "_kg-2";
export var lineItem = "_kg-3";
export var lineItemImage = "_kg-4";
export var lineItemInfo = "_kg-5";
export var lineItemText = "_kg-6";
export var lineItems = "_kg-7";
export var modalContent = "_kg-8";
export var options = "_kg-9";
export var orderName = "_kg-a";
export var refundAmount = "_kg-b";